import { DataList } from '@tiendanube/components';
import { MetafieldItem } from 'domains/Metafields/components/MetafieldInput';
import {
  MetafieldInterface,
  MetafieldSelectedInterface,
  OnChangeMetafieldType,
  SourceType,
} from 'domains/Metafields/types';
import './MetafieldsCustomerDataList.scss';

interface MetafieldsCustomerDataListProps {
  metafields: MetafieldInterface[] | null;
  selectedMetafields: MetafieldSelectedInterface[];
  source: SourceType;
  onChange: OnChangeMetafieldType;
}
export default function MetafieldsCustomerDataList({
  metafields,
  selectedMetafields,
  source,
  onChange,
}: MetafieldsCustomerDataListProps) {
  return (
    <DataList spacing="base" ruled={false}>
      {metafields?.map((metafield, index) => {
        const found = selectedMetafields.find(
          (selectedMetafield) => selectedMetafield.id === metafield.id,
        );
        const value = found?.value || '';

        return (
          <div
            className="data-list-row-wrapper data-list-row-wrapper-metafields"
            key={`${metafield.id}-${index}`}
          >
            <DataList.Row id={`${index}`}>
              <DataList.Cell width={100}>
                <MetafieldItem
                  value={value}
                  metafield={metafield}
                  source={source}
                  showDescription={!!metafield.description}
                  onChange={onChange}
                />
              </DataList.Cell>
            </DataList.Row>
          </div>
        );
      })}
    </DataList>
  );
}
